import { Box, Chip, Typography } from "@mui/material";
import EmptyState from "../shared/EmptyState";
import ThinkingMessage from "../shared/ThinkingMessage";
import ErrorMessage from "../shared/ErrorMessage";
import VersionMessage from "../shared/VersionMessage";
import ChatMessageBubble from "../shared/ChatMessageBubble";
import UserMessage from "../shared/UserMessage";
import { getDarkBubbleChipSx } from "../shared/attachmentChipTheme";
import { useTranslationApp } from "../../../../lib/i18next";
import { MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL } from "../../../../i18n/keysTranslations";

const BatchUserMessage = ({
  content,
  attachmentUrls = [],
  attachmentFileNames = {},
  isFirstUserMessage,
  onSelectVersionOne,
}) => {
  const { t } = useTranslationApp();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <UserMessage
        content={content}
        attachmentUrls={attachmentUrls}
        attachmentFileNames={attachmentFileNames}
        isFirstUserMessage={false}
      />
      {isFirstUserMessage ? (
        <Chip
          label={t(MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL, { version: 1 })}
          size="small"
          onClick={onSelectVersionOne}
          sx={{
            ...getDarkBubbleChipSx(),
            cursor: "pointer",
          }}
        />
      ) : null}
    </Box>
  );
};

const BatchChatMessage = ({
  message,
  visibleVersion,
  onVersionSelect,
  isFirstUserMessage,
}) => {
  const getMessageContent = () => {
    if (message.isThinking) {
      return <ThinkingMessage content={message.content} />;
    }

    if (message.isError) {
      return <ErrorMessage content={message.content} />;
    }

    if (message.version) {
      return (
        <VersionMessage
          content={message.content}
          isSelected={visibleVersion === message.version}
          onSelect={() => onVersionSelect(message.version)}
        />
      );
    }

    if (message.role === "user") {
      return (
        <BatchUserMessage
          content={message.content}
          attachmentUrls={message.attachmentUrls}
          attachmentFileNames={message.attachmentFileNames}
          isFirstUserMessage={isFirstUserMessage}
          onSelectVersionOne={() => onVersionSelect(1)}
        />
      );
    }

    return <Typography variant="body2">{message.content}</Typography>;
  };

  return (
    <ChatMessageBubble message={message}>
      {getMessageContent()}
    </ChatMessageBubble>
  );
};

const BatchChatMessages = ({ messages, visibleVersion, onVersionSelect }) => {
  if (messages.length === 0) {
    return <EmptyState />;
  }

  const firstUserMessageIndex = messages.findIndex(
    (message) => message.role === "user"
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {messages.map((message, index) => (
        <BatchChatMessage
          key={message.id}
          message={message}
          visibleVersion={visibleVersion}
          onVersionSelect={onVersionSelect}
          isFirstUserMessage={
            message.role === "user" && index === firstUserMessageIndex
          }
        />
      ))}
    </Box>
  );
};

export default BatchChatMessages;
